export default {
  isActive: false,
}
